module.exports = __webpack_public_path__ + "img/ok.f27856f8.svg";